import {
    FETCH_NON_ALLOCATED_EMP_REQUEST,
    FETCH_NON_ALLOCATED_EMP_SUCCESS,
    FETCH_NON_ALLOCATED_EMP_FAILURE,
} from "../constants/NonAllocatedEmpConstatns";

import NonAllocatedEmpService from "../service/NonAllocatedEmpService";

export const fetchNonAllocatedEmp = (date) => async (dispatch) => {
  if (!date) {
    console.error("Date is required");
    return;
  }

  try {
    dispatch({ type: FETCH_NON_ALLOCATED_EMP_REQUEST });

    const data = await NonAllocatedEmpService.getAll(date);

    dispatch({
      type: FETCH_NON_ALLOCATED_EMP_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_NON_ALLOCATED_EMP_FAILURE,
      payload:
        error.response?.data?.message || error.message || "Failed to fetch",
    });
  }
};
